import { Hint, Input, Label } from '@lokalise/louis';
import { useEffect, useState } from 'react';

const useInternalValue = (value: string) => {
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    return [internalValue, setInternalValue] as const;
};

interface CommitTemplateInputProps {
    value: string;
    onChange: (value: string) => void;
}

const CommitTemplateInput = ({ value, onChange }: CommitTemplateInputProps) => {
    const [internalValue, setInternalValue] = useInternalValue(value);

    return (
        <Label
            text={
                <>
                    Commit message{' '}
                    <Hint placement="top">
                        Git commits will be created with provided message. Updated file names will be appended at end of
                        messaage. Leave empty for default message.
                    </Hint>
                </>
            }
        >
            <Input
                value={internalValue}
                onChange={(e) => setInternalValue(e.target.value)}
                onBlur={(e) => onChange(e.target.value)}
            />
        </Label>
    );
};

export default CommitTemplateInput;
